export const getUserPermissions = user => {
  if (!user) return []

  let permissions = []

  if (user.is_admin || user.roles) {
    permissions.push(...(user.permissions || []))
  }

  if (user.is_organization && Array.isArray(user.organizations)) {
    for (const org of user.organizations) {
      for (const group of org.organization_user?.organization_groups || []) {
        permissions.push(...(group.permissions || []))
      }
    }
  }

  if (Array.isArray(user.organization_groups)) {
    for (const group of user.organization_groups) {
      permissions.push(...(group.permissions || []))
    }
  }

  return [...new Set(permissions)]
}

export const isPermissionAllowed = ({ user, permission }) => {
  if (!user || !permission) {
    return false
  }
  return getUserPermissions(user).includes(permission)
}
